import React from 'react';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import useAuth from '../../hooks/useAuth';
import { useSnackbar } from 'notistack';

const GuestGuard = ({ children }) => {
  const { isAuthenticated , user } = useAuth();
  const { enqueueSnackbar } = useSnackbar();

  if (isAuthenticated) {
    enqueueSnackbar('Login Successfull', {
      anchorOrigin: {
        vertical: 'top',
        horizontal: 'center',
    },
      variant: 'success'
    })
    return <Redirect to={user ? user.user_group === 'qp_creator' ? "/app/admin/qpsr/courses" : "/app/exam/home" : "/app/exam/home"} />;

  }

  return (
    <>
      {children}
    </>
  );
};

GuestGuard.propTypes = {
  children: PropTypes.node
};

export default GuestGuard;
